// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/calendarIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Calendar" aria-label="Calendar" />;
}
